import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

export const getInfoTooltip = (
  id,
  status,
  className,
  textAlign,
  lineHeight,
  placement,
  // eslint-disable-next-line consistent-return
) => {
  if (status)
    return (
      <OverlayTrigger
        trigger="click"
        placement={placement}
        overlay={
          <Popover id={id}>
            <pre style={{ margin: '1rem' }}>{JSON.stringify(status, null, 2)}</pre>
          </Popover>
        }
      >
        <i className={className} style={{ textAlign, lineHeight }} />
      </OverlayTrigger>
    )
}
